module.exports = __webpack_public_path__ + "assets/img/44a3-mv.svg";